import ActionCreator from "../actionCreator";

export default {
    setLoading: ActionCreator("UI_SET_LOADING"),
    clearLoading: ActionCreator("UI_CLEAR_LOADING"),
    errorPageRedirect: ActionCreator("ERROR_PAGE_REDIRECT"),
    maintenancePageRedirect: ActionCreator("MAINTENANCE_PAGE_REDIRECT"),
    errorResponse: ActionCreator("ERROR_RESPONSE"),
};
